import React, { useState, useEffect } from 'react';
import { Table, Typography, Popconfirm, Form, Input, message } from 'antd';
import axios from "./../../../services/http";

const TablaPendientesID = ({ pendientes, loading, updatePendingId }) => {

    const [messageApi, contextHolder] = message.useMessage();
    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({
            id_partida: (record.id_partida !== null && record.id_partida !== undefined ? record.id_partida : null),
            ...record,
        });
        setEditingKey(record.key);
    };
    const cancel = () => setEditingKey('');
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
      }) => {
        const inputNode =  <Input type="text" />;
        return (
          <td {...restProps}>
            {editing ? (
              <Form.Item
                name={dataIndex}
                style={{
                  margin: 0,
                }}
                rules={[
                  {
                    required: true,
                    message: `Ingresar ${title}!`,
                  },
                ]}
              >
                {inputNode}
              </Form.Item>
            ) : (
              children
            )}
          </td>
        );
    };
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id_partida',
            key: 'id_partida',
            editable: true,
        },
        {
            title: 'Partida',
            dataIndex: 'partida',
            key: 'partida',
        },
        {
            title: 'Código',
            dataIndex: 'codigo',
            key: 'codigo',
        },
        {
            title: 'Descripción completa',
            dataIndex: 'descripcion',
            key: 'descripcion',
        },
        {
            title: 'Unidad',
            dataIndex: 'unidad',
            key: 'unidad',
        },
        {
            title: 'Cantidad',
            dataIndex: 'cantidad',
            key: 'cantidad'
        },
        {
            title: 'Precio',
            dataIndex: 'precio',
            key: 'precio',
            render: (precio) => (precio !== null && precio !== undefined ? `$ ${numberFormat.format(precio)}` : null),
        },
        {
            title: 'Importe',
            dataIndex: 'importe',
            key: 'importe',
            render: (importe) => `$ ${numberFormat.format(importe)}`, 
        },
        {
            title: '% Participación',
            dataIndex: 'participacion',
            key: 'participacion',
            render: (participacion) => (participacion !== null && participacion !== undefined ? `${numberFormat.format(participacion)} %` : null),
        },
        {
            title: 'Acciones',
            dataIndex: 'acciones',
            key: 'acciones',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                  <span>
                    <Typography.Link
                      onClick={() => UpdatePendingId(record)}
                      style={{
                        marginInlineEnd: 8,
                      }}
                    >
                      Guardar
                    </Typography.Link>
                    <Popconfirm title="Seguro de cancelar?" onConfirm={cancel}>
                      <a>Cancelar</a>
                    </Popconfirm>
                  </span>
                ) : (
                  <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                    Editar
                  </Typography.Link>
                );
              },
        },
    ];
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record) => ({
            record,
            inputType: "text",
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record),
          }),
        };
    });

    const UpdatePendingId = async (data) => {
        try {
            const editRow = await form.validateFields();
            messageApi.open({ type: 'loading', content: 'Actualizando pendiente ID....', duration: 0 });
            const response = await axios.HTTP_POST("/api/v1/payments/pendingId/update", { id_partida: editRow.id_partida, id: data.id })
            if (response) {
                messageApi.destroy();
                message.success(response.data.message);
                setEditingKey('');
                updatePendingId(true);
            }
        } catch (e) {
            console.log("Error - UpdatePendingId: ", e);
        }
    }

    return (
        <>
            <Form form={form} component={false}>
                <Table 
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    dataSource={pendientes} 
                    columns={mergedColumns}
                    rowKey={record => record.id}
                    loading={loading} 
                />
            </Form>
        </>
    )
}

export default TablaPendientesID;